module.exports = __webpack_public_path__ + "images/logo.png?v=e0468be1f90868bc489ca56eeff6bc72";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 625
// module chunks = 0